module.exports = __webpack_public_path__ + "static/media/4.350f1610.jpg";